import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";

@Injectable()
export class ElasticsearchService extends ServiceProvider {

  protected url = '/api/v1/elasticsearch';

  constructor(
  ) {
    super(
      AppInjector.get(HttpClient),
      AppInjector.get(ApiUrl),
      ''
    );
  }
  reindexProducts(data): Observable<any> {
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/reindex', data).pipe(
      catchError(
        error => {
          throw error;
        }
      )
    );
  }
}
